export type ThemeTokens = {
    primary: string;
    onPrimary: string;
    primaryContainer: string;
    onPrimaryContainer: string;

    secondary: string;
    onSecondary: string;
    secondaryContainer: string;
    onSecondaryContainer: string;

    tertiary: string;
    onTertiary: string;
    tertiaryContainer: string;
    onTertiaryContainer: string;

    error: string;
    onError: string;
    errorContainer: string;
    onErrorContainer: string;

    primaryFixed: string;
    primaryFixedDim: string;
    onPrimaryFixed: string;
    onPrimaryFixedVariant: string;

    secondaryFixed: string;
    secondaryFixedDim: string;
    onSecondaryFixed: string;
    onSecondaryFixedVariant: string;

    tertiaryFixed: string;
    tertiaryFixedDim: string;
    onTertiaryFixed: string;
    onTertiaryFixedVariant: string;

    surface: string;
    onSurface: string;

    surfaceDim: string;
    surfaceBright: string;

    surfaceContainerLowest: string;
    surfaceContainerLow: string;
    surfaceContainer: string;
    surfaceContainerHigh: string;
    surfaceContainerHighest: string;

    surfaceVariant: string;
    onSurfaceVariant: string;

    outline: string;
    outlineVariant: string;

    inverseSurface: string;
    inverseOnSurface: string;
    inversePrimary: string;
    inverseOnPrimary: string;

    shadow: string;
    scrim: string;

    surfaceTintColor: string;

    background: string;
    onBackground: string;

    info: string;
    onInfo: string;
    infoContainer: string;
    onInfoContainer: string;

    success: string;
    onSuccess: string;
    successContainer: string;
    onSuccessContainer: string;

    warning: string;
    onWarning: string;
    warningContainer: string;
    onWarningContainer: string;
};

export const LightTokensDefault: ThemeTokens = {
    primary: '#006495',
    onPrimary: '#ffffff',
    primaryContainer: '#cbe6ff',
    onPrimaryContainer: '#001e30',
    secondary: '#50606f',
    onSecondary: '#ffffff',
    secondaryContainer: '#d4e4f6',
    onSecondaryContainer: '#0d1d29',
    tertiary: '#66587b',
    onTertiary: '#ffffff',
    tertiaryContainer: '#ecdcff',
    onTertiaryContainer: '#211634',
    error: '#ba1a1a',
    onError: '#ffffff',
    errorContainer: '#ffdad6',
    onErrorContainer: '#410002',
    primaryFixed: '#cbe6ff',
    primaryFixedDim: '#8fcdff',
    onPrimaryFixed: '#001e30',
    onPrimaryFixedVariant: '#004b71',
    secondaryFixed: '#d4e4f6',
    secondaryFixedDim: '#b8c8d9',
    onSecondaryFixed: '#0d1d29',
    onSecondaryFixedVariant: '#394856',
    tertiaryFixed: '#ecdcff',
    tertiaryFixedDim: '#d0bfe7',
    onTertiaryFixed: '#211634',
    onTertiaryFixedVariant: '#4d4162',
    surface: '#f9f9fc',
    onSurface: '#1a1c1e',
    surfaceDim: '#d9dadd',
    surfaceBright: '#f9f9fc',
    surfaceContainerLowest: '#ffffff',
    surfaceContainerLow: '#f3f3f6',
    surfaceContainer: '#edeef1',
    surfaceContainerHigh: '#e8e8eb',
    surfaceContainerHighest: '#e2e2e5',
    surfaceVariant: '#dee3ea',
    onSurfaceVariant: '#41474d',
    outline: '#72787e',
    outlineVariant: '#c1c7ce',
    inverseSurface: '#2f3133',
    inverseOnSurface: '#f0f0f3',
    inversePrimary: '#8fcdff',
    inverseOnPrimary: '',
    shadow: '#000000',
    scrim: '#000000',
    surfaceTintColor: '#006495',
    background: '#f9f9fc',
    onBackground: '#1a1c1e',
    info: '#006397',
    onInfo: '#ffffff',
    infoContainer: '#cce5ff',
    onInfoContainer: '#001d31',
    success: '#006d43',
    onSuccess: '#ffffff',
    successContainer: '#92f7bc',
    onSuccessContainer: '#002111',
    warning: '#795900',
    onWarning: '#ffffff',
    warningContainer: '#ffdf9f',
    onWarningContainer: '#261a00',
};

export const DarkTokensDefault: ThemeTokens = {
    primary: '#8fcdff',
    onPrimary: '#003450',
    primaryContainer: '#004b71',
    onPrimaryContainer: '#cbe6ff',
    secondary: '#b8c8d9',
    onSecondary: '#22323f',
    secondaryContainer: '#394856',
    onSecondaryContainer: '#d4e4f6',
    tertiary: '#d0bfe7',
    onTertiary: '#362b4a',
    tertiaryContainer: '#4d4162',
    onTertiaryContainer: '#ecdcff',
    error: '#ffb4ab',
    onError: '#690005',
    errorContainer: '#93000a',
    onErrorContainer: '#ffdad6',
    primaryFixed: '#cbe6ff',
    primaryFixedDim: '#8fcdff',
    onPrimaryFixed: '#001e30',
    onPrimaryFixedVariant: '#004b71',
    secondaryFixed: '#d4e4f6',
    secondaryFixedDim: '#b8c8d9',
    onSecondaryFixed: '#0d1d29',
    onSecondaryFixedVariant: '#394856',
    tertiaryFixed: '#ecdcff',
    tertiaryFixedDim: '#d0bfe7',
    onTertiaryFixed: '#211634',
    onTertiaryFixedVariant: '#4d4162',
    surface: '#111416',
    onSurface: '#e2e2e5',
    surfaceDim: '#111416',
    surfaceBright: '#37393c',
    surfaceContainerLowest: '#0c0e11',
    surfaceContainerLow: '#1a1c1e',
    surfaceContainer: '#1e2022',
    surfaceContainerHigh: '#282a2d',
    surfaceContainerHighest: '#333537',
    surfaceVariant: '#41474d',
    onSurfaceVariant: '#c1c7ce',
    outline: '#8b9198',
    outlineVariant: '#41474d',
    inverseSurface: '#e2e2e5',
    inverseOnSurface: '#2f3133',
    inversePrimary: '#006495',
    inverseOnPrimary: '',
    shadow: '#000000',
    scrim: '#000000',
    surfaceTintColor: '#8fcdff',
    background: '#111416',
    onBackground: '#e2e2e5',
    info: '#92ccff',
    onInfo: '#003351',
    infoContainer: '#004b73',
    onInfoContainer: '#cce5ff',
    success: '#76daa1',
    onSuccess: '#003920',
    successContainer: '#005231',
    onSuccessContainer: '#92f7bc',
    warning: '#f8bd26',
    onWarning: '#402d00',
    warningContainer: '#5b4300',
    onWarningContainer: '#ffdf9f',
};
